import React from 'react';
import styled from 'styled-components';
import { XIcon } from '@grnhse/seedling/lib/azalea/icons';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/DEPRECATED/components/Input'. 'app/webpack/javascripts/shared/DEPRECATED/components/Input.js' implicitly has an 'any' type.
import Input from 'shared/DEPRECATED/components/Input';
import { withLocalePrefix } from 'shared/utils/translation';
import { SmallContentContainer } from '../../components';

type Props = {
  emails: Array<string>;
  onChangeEmails: any;
};

const t = withLocalePrefix('gdpr.data_retention_rules.view.edit.notifications');

export default function ManualEmailEntry(props: Props) {
  const { emails, onChangeEmails } = props;

  const onDeleteEmail = (emailIndex: number) => {
    emails.splice(emailIndex, 1);
    onChangeEmails(emails);
  };

  const onAddEmail = () => {
    // @ts-expect-error - TS2769 - No overload matches this call.
    onChangeEmails(emails.concat(undefined));
  };

  const onChangeEmail = (event: any, emailIndex: number) => {
    emails[emailIndex] = event.currentTarget.value;
    onChangeEmails(emails);
  };

  return (
    <React.Fragment>
      <div id="emails">
        {emails.map((email, i) => {
          return (
            <SmallContentContainer key={i}>
              <EmailInput
                placeholder="name@example.com"
                value={email}
                // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
                onChange={(e) => onChangeEmail(e, i)}
              />
              <ClickableSpan onClick={() => onDeleteEmail(i)}>
                <XIcon />
              </ClickableSpan>
            </SmallContentContainer>
          );
        })}
      </div>
      <div>
        <a onClick={onAddEmail} href="#">
          {`+ ${t('add_email')}`}
        </a>
      </div>
    </React.Fragment>
  );
}

const ClickableSpan = styled.span`
  cursor: pointer;
  display: inline-block;
  height: 33px;
  padding-left: 10px;
  position: relative;
  top: 5px;
  vertical-align: middle;
`;
ClickableSpan.displayName = 'ClickableSpan';

const EmailInput = styled(Input)`
  display: inline-block;
  width: 455px;
`;
EmailInput.displayName = 'EmailInput';
